import React from "react";
import Loader from "@components/atoms/Loader";
import { Modal } from "react-native";
import styled from "styled-components/native";

type LoaderModelProps = {
  isOpen: boolean;
  onClose: () => void;
  url?: string;
};

const LoaderModel = ({ isOpen, onClose }: LoaderModelProps) => {
  return (
    <Modal
      visible={isOpen}
      transparent={true}
      animationType="fade"
      onDismiss={onClose}
      supportedOrientations={["landscape", "portrait"]}
    >
      <Overlay>
        <Loader />
      </Overlay>
    </Modal>
  );
};

const Overlay = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme["core-02"]};
  opacity: 0.8;
`;

export default LoaderModel;
